<template>
    <div class="popup" v-bind:class="{'is-active': show}" @click.stop="cancel">
        <div class="popup__content w-100 popup__content--small" @click.stop="cancel">

            <div class="popup__body py-8 text-center" @click.stop="">
                <button @click="cancel" class="popup__close popup__close--absolute"></button>
                <div class="title-3 mb-4 mt-1" v-html="message"></div>
                <button class="btn btn--popup btn--black mr-2" @click.prevent="confirm">{{$t('components.ConfirmDeletePopup.remove')}}</button>
                <button class="btn btn--popup btn--white" @click.prevent="cancel">{{$t('components.ConfirmDeletePopup.cancel')}}</button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            show: {
                type: Boolean,
                default: false,
            },
            message: {
                type: String
            }
        },
        watch: {
            show: function(newVal) {
                if(newVal) {
                    disable_scroll();
                } else {
                    enable_scroll();
                }
            }
        },
        methods: {
            cancel() {
                this.$emit('cancel');
            },
            confirm() {
                this.$emit('confirm');
            }
        }
    };
</script>
